import React from "react";
import SuspenseWrapper from "../../component/SuspenseWrapper";
import { SubMenu } from "react-pro-sidebar";
import MarketFacingTitle from "@/pages/master/MarketFacingTitle/MarketFacingTitle";

const Gender = React.lazy(() => import("@/pages/master/gender/Gender"));

const Form = React.lazy(() => import("@/pages/master/form/MainIndex"));
const Organization = React.lazy(() =>
  import("@/pages/master/organization/index")
);
const SubOrganization = React.lazy(() =>
  import("@/pages/master/subOrganization/index")
);
const Business = React.lazy(() => import("@/pages/master/business/index"));
const Band = React.lazy(() => import("@/pages/master/band/index"));
const BloodGroup = React.lazy(() => import("@/pages/master/bloodGroup/index"));

const Division = React.lazy(() => import("@/pages/master/division/index"));
const Function = React.lazy(() => import("@/pages/master/function/index"));
const Grade = React.lazy(() => import("@/pages/master/grade/index"));
const WorkLocation = React.lazy(() =>
  import("@/pages/master/workLocation/index")
);

const RoleOfIntake = React.lazy(() =>
  import("@/pages/master/roleofIntake/index")
);
const Department = React.lazy(() => import("@/pages/master/department/index"));
const Designation = React.lazy(() =>
  import("@/pages/master/designation/index")
);
const Document = React.lazy(() => import("@/pages/master/document/index"));
const Shift = React.lazy(() => import("@/pages/master/shift/index"));
const CompanyPolicy = React.lazy(() =>
  import("@/pages/master/companyPolicy/Index")
);
const State = React.lazy(() => import("@/pages/master/state/index"));
const Zone = React.lazy(() => import("@/pages/master/zone/index"));
const Client = React.lazy(() => import("@/pages/master/client/index"));
const HelpDesk = React.lazy(() => import("@/pages/master/helpDesk/index"));
const AdminEvents = React.lazy(() => import("@/pages/event/AdminEvents"));
const AdminHolidaysall = React.lazy(() =>
  import("@/pages/master/adminHolidays/AdminHoliday")
);
const AdminViewAll = React.lazy(() =>
  import("@/pages/master/adminHolidays/ViewAll")
);
const AdminRestrictedHoliday = React.lazy(() =>
  import("@/pages/master/adminHolidays/RestrictedHoliday")
);
const AdminHoliday = React.lazy(() =>
  import("@/pages/master/adminHolidays/Holiday")
);
const Menu = React.lazy(() => import("@/pages/master/menu/index"));
const Submenu = React.lazy(() => import("@/pages/master/submenu/index"));

const RoleAndPermissionLink = React.lazy(() =>
  import("@/pages/master/rolesAndPermission/RolesAndPermission")
);
const AddRole = React.lazy(() =>
  import("@/pages/master/rolesAndPermission/Roles")
);
const DocumentCenterReport = React.lazy(() =>
  import("@/pages/master/documentCenterReport/DocumentCenterReport")
);
const ProfileLog = React.lazy(() => import("@/pages/master/profileLog/index"));
// const SubDivision = React.lazy(() => import("@/pages/master/subDivision/index"));
const Settings = [
  {
    path: "organization",
    element: (
      <SuspenseWrapper>
        <Organization />
      </SuspenseWrapper>
    ),
  },
  {
    path: "subOrganization",
    element: (
      <SuspenseWrapper>
        <SubOrganization />
      </SuspenseWrapper>
    ),
  },
  {
    path: "business",
    element: (
      <SuspenseWrapper>
        <Business />
      </SuspenseWrapper>
    ),
  },
  {
    path: "band",
    element: (
      <SuspenseWrapper>
        <Band />
      </SuspenseWrapper>
    ),
  },
  {
    path: "band",
    element: (
      <SuspenseWrapper>
        <Band />
      </SuspenseWrapper>
    ),
  },
  {
    path: "bloodGroup",
    element: (
      <SuspenseWrapper>
        <BloodGroup />
      </SuspenseWrapper>
    ),
  },
  {
    path: "division",
    element: (
      <SuspenseWrapper>
        <Division />
      </SuspenseWrapper>
    ),
  },
  {
    path: "function",
    element: (
      <SuspenseWrapper>
        <Function />
      </SuspenseWrapper>
    ),
  },
  {
    path: "Grade",
    element: (
      <SuspenseWrapper>
        <Grade />
      </SuspenseWrapper>
    ),
  },
  {
    path: "workLocation",
    element: (
      <SuspenseWrapper>
        <WorkLocation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "roleOfIntake",
    element: (
      <SuspenseWrapper>
        <RoleOfIntake />
      </SuspenseWrapper>
    ),
  },
  {
    path: "department",
    element: (
      <SuspenseWrapper>
        <Department />
      </SuspenseWrapper>
    ),
  },
  {
    path: "designation",
    element: (
      <SuspenseWrapper>
        <Designation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "document",
    element: (
      <SuspenseWrapper>
        <Document />
      </SuspenseWrapper>
    ),
  },
  {
    path: "shift-master",
    element: (
      <SuspenseWrapper>
        <Shift />
      </SuspenseWrapper>
    ),
  },
  {
    path: "companyPolicy",
    element: (
      <SuspenseWrapper>
        <CompanyPolicy />
      </SuspenseWrapper>
    ),
  },
  {
    path: "state",
    element: (
      <SuspenseWrapper>
        <State />
      </SuspenseWrapper>
    ),
  },
  {
    path: "zone",
    element: (
      <SuspenseWrapper>
        <Zone />
      </SuspenseWrapper>
    ),
  },
  {
    path: "client",
    element: (
      <SuspenseWrapper>
        <Client />
      </SuspenseWrapper>
    ),
  },
  {
    path: "helpDeskSpoc",
    element: (
      <SuspenseWrapper>
        <HelpDesk />
      </SuspenseWrapper>
    ),
  },
  {
    path: "menu",
    element: (
      <SuspenseWrapper>
        <Menu />
      </SuspenseWrapper>
    ),
  },
  {
    path: "submenu",
    element: (
      <SuspenseWrapper>
        <Submenu />
      </SuspenseWrapper>
    ),
  },
  {
    path: "rolesAndPermission",
    element: (
      <SuspenseWrapper>
        <RoleAndPermissionLink />
      </SuspenseWrapper>
    ),
  },
  {
    path: "addRoles",
    element: (
      <SuspenseWrapper>
        <AddRole />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminEvents",
    element: (
      <SuspenseWrapper>
        <AdminEvents />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminHolidaysall",
    element: (
      <SuspenseWrapper>
        <AdminHolidaysall />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminHolidays",
    element: (
      <SuspenseWrapper>
        <AdminViewAll />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminRestrictedHolidays",
    element: (
      <SuspenseWrapper>
        <AdminRestrictedHoliday />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminViewHolidays",
    element: (
      <SuspenseWrapper>
        <AdminHoliday />
      </SuspenseWrapper>
    ),
  },
  {
    path: "documentCenterReport",
    element: (
      <SuspenseWrapper>
        <DocumentCenterReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "gender",
    element: (
      <SuspenseWrapper>
        <Gender />
      </SuspenseWrapper>
    ),
  },
  {
    path: "marketFacingTitle",
    element: (
      <SuspenseWrapper>
        <MarketFacingTitle />
      </SuspenseWrapper>
    ),
  },
    {
    path: "profile-log",
    element: (
      <SuspenseWrapper>
        <ProfileLog />
      </SuspenseWrapper>
    ),
  },
  // {
  //   path: "sub-division",
  //   element: (
  //     <SuspenseWrapper>
  //       <SubDivision />
  //     </SuspenseWrapper>
  //   ),
  // },
];

export default Settings;
